import styled from 'styled-components';

import { basicSmallTextStyle, Message } from '@dreryk/react-components';

export const StyledMessage = styled(Message)`
   ${basicSmallTextStyle}
   align-items: center;
   padding: 10px 0;
`;

StyledMessage.displayName = 'StyledMessage';
